<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "PermissionAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  